import type { StoryArtSources, Theme } from '@goodtime/engine';
import { symbolUrl } from '../components/trail/trailThemes';
import fenTalkingUrl from '../assets/avatar/friendly_fox/talking.png';
import fenCheeringUrl from '../assets/avatar/friendly_fox/cheering.png';
import fenWorriedUrl from '../assets/avatar/friendly_fox/worried.png';
import beaUrl from '../assets/avatar/brave_bea/idle.png';
import boxUrl from '../assets/story/mystery_box.png';
import takingsUrl from '../assets/story/takings_header.png';
import morningUrl from '../assets/story/morning_header.png';
import starUrl from '../assets/icon/star.png';
import x2Url from '../assets/item/x2_bonus.png';
import potGoldUrl from '../assets/road/pot_gold.png';
import flowerUrl from '../assets/reel/forest/flower.png';
import wildUrl from '../assets/reel/forest/vine_wild.png';
import louUrl from '../assets/story/visitor_lou.png';
import willaUrl from '../assets/story/visitor_willa.png';
import carlUrl from '../assets/story/visitor_carl.png';
import chestUrl from '../assets/story/treasure_chest.png';
import scrollUrl from '../assets/story/map_scroll.png';
import piece1Url from '../assets/story/map_piece_1.png';
import piece2Url from '../assets/story/map_piece_2.png';
import piece3Url from '../assets/story/map_piece_3.png';

/**
 * The story's art (Phase 3) on a road slot. Its own pieces are fetched only
 * when the story is on for the player; the coin, gem, free-spin and Wheel Run
 * pictures are the ones the slot has already loaded, and the modifiers show
 * the slot's own collector and wild (Forest's when a slot has none).
 */
export function storyArtSources(theme: Theme | null): StoryArtSources {
  return {
    fen_talking: { url: fenTalkingUrl },
    fen_cheering: { url: fenCheeringUrl },
    fen_worried: { url: fenWorriedUrl },
    bea: { url: beaUrl },
    box: { url: boxUrl },
    takings: { url: takingsUrl },
    morning: { url: morningUrl },
    star: { url: starUrl },
    mod_streak: { url: x2Url },
    mod_golden: { url: potGoldUrl },
    mod_bloom: { url: symbolUrl(theme, 'cherry') ?? flowerUrl },
    mod_wild: { url: symbolUrl(theme, 'star') ?? wildUrl },
    // The visitors, painted in the friends' cartoon style (the wheel game's
    // portraits of them stay as they are).
    visitor_lou: { url: louUrl },
    visitor_willa: { url: willaUrl },
    visitor_carl: { url: carlUrl },
    treasure_chest: { url: chestUrl },
    map_scroll: { url: scrollUrl },
    map_piece_1: { url: piece1Url },
    map_piece_2: { url: piece2Url },
    map_piece_3: { url: piece3Url },
    coin: { alias: 'shared:icon:coin' },
    gem: { alias: 'shared:icon:gem' },
    spin: { alias: 'shared:icon:spin' },
    run: { alias: `road:ring_${theme?.id ?? 'forest'}` },
  };
}
